var exports = {
  "x9": "outerWrapper__Iqf-yd",
  "xg": "outerWrapperStickied__PACNio",
  "iJ": "innerWrapper__ifE6X6",
  "ED": "innerWrapperStickied__yQ-rKz",
  "F4": "innerWrapperNotStickied__Q-v4vh",
};

module.exports = exports;
